// use a rather large value so that also large cross sections do not overlap with the labels
export const LABEL_POSITION_OFFSET = 0.15
export const LABEL_SCALE = 0.2
export const LABEL_SCALE_SINGLE_LINE = 0.1
export const VERTICAL_SLAB_LABEL_OFFSET = 0.02

/** Keeps the member label slightly narrower than the cross section it sits on */
export const MEMBER_LABEL_FONT_SIZE_INSET = 0.01

/** Extrusion beyond the cross section, so the text stays visible from both sides */
export const MEMBER_TEXT_DEPTH_DELTA = 0.02
export const COLUMN_TEXT_DEPTH_DELTA = 0.001

/** `Text3DThree`s default text depth, used by the flat (plan view) labels */
export const FLAT_TEXT_DEPTH = 0.0001
export const SLAB_TEXT_DEPTH = 0.005

export const WALL_BORDER_WIDTH = 0.01
export const SLAB_BORDER_WIDTH = 0.005

/**
 * `Text3DThree` renders glyphs about 1.4x larger than their nominal `scale`,
 * because `TextGeometry`s `size` maps onto the typeface font's resolution
 * rather than its em box. Measured at nominal 0.15: TextGeometry 0.1524 high
 * vs troika 0.1096, a ratio of 1.39 (1.41 on width). This is the same factor
 * `TEXT_3D_ADDITIONAL_WIDTH_SCALE` already applies to its width estimates.
 *
 * Descriptors carry the true rendered size, so `Text3DThree` divides by this
 * and renderers with a true em size (troika, canvas) use it as is.
 */
export const TEXT_3D_GLYPH_SIZE_FACTOR = 1.4
